import React from 'react';
import { Box } from '@mui/material';
import { endPoints } from 'api/endpoints';
import FormCard from 'pages/myidm/components/form-card';
import PropTypes from 'prop-types';
import AccordianList from '../../accordian-list/AccordianList';

const MultipleADGroupMembers = ({ multipleAdGroups, order }) => {
    // Local state for inputList, initialized from multipleAdGroups
    const [inputList, setInputList] = React.useState(() => (multipleAdGroups || []).map((group) => group?.adGroup).filter(Boolean));
    const [expandedAccordian, setExpandedAccordian] = React.useState({});

    // Keep inputList in sync with multipleAdGroups
    React.useEffect(() => {
        const list = (multipleAdGroups || []).map((group) => group?.adGroup).filter(Boolean);
        setInputList(list);

        if (list.length && list.length === 1) {
            setExpandedAccordian({ [list[0]]: true });
        }
    }, [multipleAdGroups]);

    return (
        <>
            {inputList.length > 0 && (
                <Box>
                    <FormCard title="AD Group Members List" gap={0} showDivider={false}>
                        <Box data-testid="members-list" sx={{ width: '100%' }}>
                            {inputList.map((inputValue) => (
                                <AccordianList
                                    key={inputValue}
                                    title={inputValue}
                                    isExpanded={!!expandedAccordian[inputValue]}
                                    onToggle={() =>
                                        setExpandedAccordian((prev) => ({
                                            ...prev,
                                            [inputValue]: !prev[inputValue],
                                        }))
                                    }
                                    endPoint={endPoints?.myIdm?.adGroupMembersApiV2}
                                    order={order}
                                />
                            ))}
                        </Box>
                    </FormCard>
                </Box>
            )}
        </>
    );
};

MultipleADGroupMembers.propTypes = {
    multipleAdGroups: PropTypes.array.isRequired,
    order: PropTypes.any.isRequired,
};

export default MultipleADGroupMembers;
